import { render, staticRenderFns } from "./detailsNotify.vue?vue&type=template&id=5310246b&scoped=true&"
import script from "./detailsNotify.vue?vue&type=script&lang=js&"
export * from "./detailsNotify.vue?vue&type=script&lang=js&"
import style0 from "./detailsNotify.vue?vue&type=style&index=0&id=5310246b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5310246b",
  null
  
)

export default component.exports